import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SquareWarnIcon } from '@/components/common/icon';
import { ModalShowImg } from '@/components/web/components/ModalTakeOrder/audienceDemographics';

/** Shared by the real channel-data view and the local acceptance fixture. */
export default function CreatorPackageAudienceNotice() {
  const { t } = useTranslation();
  const [showPreview, setShowPreview] = useState(false);

  return (
    <>
      <div
        data-testid="package-audience-notice"
        className="mt-4 flex items-start gap-2 rounded-lg bg-[#EFF6FF] px-4 py-2"
      >
        <span aria-hidden="true" className="flex-shrink-0 py-[3px]">
          <SquareWarnIcon className="block h-5 w-5" />
        </span>
        <p className="m-0 min-w-0 flex-1 break-words font-['DM_Sans'] text-sm font-normal leading-[22px] tracking-[-0.14px] text-[#292524]">
          {t('multi_platform.quote.audience_help_description', {
            defaultValue:
              'Sharing your audience data helps brands understand your audience and speed up review, so promoted content is accurately targeted.'
          })}{' '}
          <button
            type="button"
            className="inline border-0 bg-transparent p-0 text-left text-[#2563EB] [font:inherit]"
            onClick={() => setShowPreview(true)}
          >
            {t('multi_platform.quote.audience_preview', {
              defaultValue: "See how it appears on the brand's side"
            })}
          </button>
        </p>
      </div>
      <ModalShowImg isOpen={showPreview} setIsOpen={setShowPreview} />
    </>
  );
}
